import {ValidationErrorKeys} from '@hconnect/common/consts'
import {type TFunction} from 'i18next'
import {object, string} from 'yup'

import {YesNoFormValue} from '../../types'

const COMMENT_MAX_LENGTH = 256

const getYesNoWithCommentSchema = ({t}: {t: TFunction}) =>
  object().shape({
    value: string()
      .oneOf([YesNoFormValue.YES, YesNoFormValue.NO])
      .required(t(ValidationErrorKeys.REQUIRED)),
    comment: string().when('value', {
      is: YesNoFormValue.NO,
      then: string()
        .required(t(ValidationErrorKeys.REQUIRED))
        .max(COMMENT_MAX_LENGTH, t(ValidationErrorKeys.MAX_LENGTH, {max: COMMENT_MAX_LENGTH})),
      otherwise: string()
    })
  })

const getUserSchema = ({t}: {t: TFunction}) =>
  object().shape({
    id: string().required(t(ValidationErrorKeys.REQUIRED)),
    name: string().required(t(ValidationErrorKeys.REQUIRED))
  })

const REASON_TO_WORK_SAFE_MAX_LENGTH = 128

export const getSafetyValidationSchema = ({t}: {t: TFunction}) =>
  object().shape({
    peopleInformed: getYesNoWithCommentSchema({t}),
    rightTools: getYesNoWithCommentSchema({t}),
    fitForDuty: getYesNoWithCommentSchema({t}),
    riskRecognized: getYesNoWithCommentSchema({t}),
    reasonToWorkSafe: string().max(
      REASON_TO_WORK_SAFE_MAX_LENGTH,
      t(ValidationErrorKeys.MAX_LENGTH, {max: REASON_TO_WORK_SAFE_MAX_LENGTH})
    ),
    supervisor: getUserSchema({t}).nullable().required(t(ValidationErrorKeys.REQUIRED))
  })
